import React, { useState } from 'react';
import './MissingWordCard.css';
import avatarLexi from '../assets/avatar-lexi.svg';
import avatarSam from '../assets/avatar-sam.svg';
import avatarOwlbert from '../assets/avatar-owlbert.svg';

const MissingWordCard = ({ word }) => {
  const [currentPersona, setCurrentPersona] = useState('sam');

  const personas = {
    lexi: {
      avatar: avatarLexi,
      name: "Teacher Lexi",
      message: "Well, it seems this word isn't in our dictionary just yet! But don't worry—language is always evolving. Maybe it's a rare gem, a new slang term, or a word waiting to be discovered. If you think it should be included, let us know!"
    },
    sam: {
      avatar: avatarSam,
      name: "Slang Sam",
      message: "Whoa, looks like this word slipped through the cracks! Maybe it's a fresh new slang, a rare fancy term, or just one of those words people don't look up often. If it's giving you trouble, let us know—we're always up for adding more words to the mix!"
    },
    owlbert: {
      avatar: avatarOwlbert,
      name: "Owlbert",
      message: "Imagine a great library filled with words, each one carefully placed on a shelf. But today, you've opened a book to find an empty page. This word isn't in our collection yet, but maybe you can be the one to bring it to life. Tell us about it, and we just might add it to our story!"
    }
  };

  const currentMessage = personas[currentPersona];

  return (
    <div className="missing-word-card">
      <div className="missing-header">
        <h2 className="missing-title">Oops! We Don't Have That Word… Yet!</h2>
      </div>

      <div className="missing-content">
        <div className="main-message">
          <div className="main-avatar-container">
            <img src={currentMessage.avatar} alt="" className="main-avatar-image" />
            <div className="play-button">▶</div>
          </div>
          <p className="message-text">
            {currentMessage.message}
          </p>
        </div>

        <div className="avatar-switcher">
          {Object.entries(personas)
            .filter(([key]) => key !== currentPersona)
            .map(([key, persona]) => (
              <button
                key={key}
                className="avatar-switch-button"
                onClick={() => setCurrentPersona(key)}
              >
                <img src={persona.avatar} alt={persona.name} className="small-avatar" />
              </button>
            ))}
        </div>
      </div>
    </div>
  );
};

export default MissingWordCard; 